/* eslint-disable react/prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import Spinner from '@prisjakt/ui-spinner';
import { bemGenerator } from '@prisjakt/ui-base';

import './index.scss';

const styles = bemGenerator('pj-spinner');

const Loader = props => (
  <div
    style={{ height: '70vh' }}
    className={styles.block.withModifier({
      'fade-in': props.fadeIn,
    })}
  >
    <div>
      <Spinner size={48} type="standard" isActive />
    </div>
  </div>
);

Loader.propTypes = {
  fadeIn: PropTypes.bool,
};

Loader.defaultProps = {
  fadeIn: true,
};

export default Loader;
